import { Component, OnInit } from '@angular/core';
import { ContactosService } from '../../../services/contactos.service';
import { AuthService } from '../../../services/auth.service';
import { ApiResponse } from '../../../interfaces/common.interfaces';
import { ContactResponse } from '../../../interfaces/contactos.interface';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MapaSucursalesComponent } from './components/mapa-sucursales/mapa-sucursales.component';
@Component({
  selector: 'app-contactos',
  standalone: true,
  imports: [CommonModule, FormsModule, MapaSucursalesComponent],
  templateUrl: './contactos.component.html',
  styleUrl: './contactos.component.css',
})
export class ContactosComponent implements OnInit {
  public producerNumber?: number | null;
  public contactsDataResponse?: ContactResponse;
  public selectedTerritory: number = 7;
  public title: string = '';
  public filteredBranches: {
    branchCode: number;
    branchDescription: string;
    street: string;
    latitude: string;
    longitude: string;
    territoryCode: number;
  }[] = [];
  public branchesData?: {
    branches: {
      branchCode: number;
      branchDescription: string;
      street: string;
      latitude: string;
      longitude: string;
      territoryCode: number;
    }[];
    territories: {
      territoryCode: number;
      territoryDescription: string;
    }[];
  };
  public contactsData?: {
    collectionAgent: string;
    damagesAgent: string;
    lifeAgent: string;
  };

  constructor(
    private contactService: ContactosService,
    private authService: AuthService
  ) {
    this.producerNumber = this.authService.getProducerNumber();
    this.title = 'Contactos generales';
  }

  ngOnInit(): void {
    this.getContact();
  }

  // Obtención de datos de contactos
  getContact() {
    this.contactService
      .getContact({ producerNumber: this.producerNumber! })
      .subscribe({
        next: ({ data }: ApiResponse<ContactResponse>) => {
          this.contactsDataResponse = data;
          this.branchesData = this.mapDataBranches(data);
          this.getBranchesByTerritory(this.selectedTerritory);
          this.contactsData = this.mapDataContacts(data);
        },
        error: (error) => {
          console.error('Error al cargar documentos:', error);
          if (error.status === 404) {
            window.alert('No se encontraron datos de contactos');
          }
        },
      });
  }

  // Mapeo de datos de sucursales
  mapDataBranches(data: ContactResponse): {
    branches: {
      branchCode: number;
      branchDescription: string;
      street: string;
      latitude: string;
      longitude: string;
      territoryCode: number;
    }[];
    territories: {
      territoryCode: number;
      territoryDescription: string;
    }[];
  } {
    const branches: {
      branchCode: number;
      branchDescription: string;
      street: string;
      latitude: string;
      longitude: string;
      territoryCode: number;
    }[] = [];
    const territories: {
      territoryCode: number;
      territoryDescription: string;
    }[] = [];

    for (let branch of data.branch) {
      if (
        !territories.map((t) => t.territoryCode).includes(branch.territoryCode)
      ) {
        territories.push({
          territoryCode: branch.territoryCode,
          territoryDescription: branch.territoryDescription,
        });
      }
      branches.push({
        branchCode: branch.branchCode,
        branchDescription: branch.branchDescription,
        street: branch.street,
        latitude: branch.latitude,
        longitude: branch.longitude,
        territoryCode: branch.territoryCode,
      });
    }
    return { branches, territories };
  }

  // Obtención de sucursales por territorio
  getBranchesByTerritory(territoryCode: number) {
    this.filteredBranches = this.branchesData!.branches.filter(
      (branch) => branch.territoryCode == territoryCode
    );
  }

  // Mapeo de datos de contactos
  mapDataContacts(data: ContactResponse): {
    collectionAgent: string;
    damagesAgent: string;
    lifeAgent: string;
  } {
    return {
      collectionAgent: data.contacts.collectionAgent,
      damagesAgent: data.contacts.damagesAgent.split('-')[1],
      lifeAgent: data.contacts.lifeAgent.split('-')[1],
    };
  }


  /**
 * Obtiene el texto `content` del ítem de `contactNumber` con el id dado.
 * @param contactId Identificador del registro en API (ej. 24 asistente virtual).
 * @returns `content` o cadena vacía si no existe.
 */
getContactContentById(contactId: number): string {
  return (
    this.contactsDataResponse?.contactNumber?.find((contact) => contact.id === contactId)
      ?.content ?? ''
  );
}
}
